import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ADMIN_ROLES, EMPLOYEE_ROLES } from '../constants';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    const fallback = ADMIN_ROLES.includes(user?.role)
      ? '/admin/dashboard'
      : EMPLOYEE_ROLES.includes(user?.role)
      ? '/employee/reports'
      : '/login';
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ProtectedRoute;
